/**
 * 챕터 해금 탭 레드닷 판정 (순수) — Phaser 의존 0의 단위 테스트 대상.
 *
 * 챕터 도달로 잠금이 풀린(unlockChapter>1) 탭에 "새로 열렸다"는 알림 레드닷을 띄우고,
 * 그 탭에 처음 진입하면(seen에 포함) 닷을 소비한다. 도감 조각 알림(codexRedDot)과 별개로,
 * 탭 자체의 해금 이벤트를 알린다. 진입 기록(seen)은 SaveData.tabUnlockSeen으로 영속된다.
 *
 * 표시 조건 = `unlockChapter > 1 && bestChapter >= unlockChapter && tabId ∉ seen`.
 * 소비자: SegmentedTabBar(배지 렌더) · GameScene(잠금 갱신 시 레드닷 재계산).
 */
import { TAB_ORDER, type TabId } from "./tabCatalog.js";
import { isTabLocked, tabUnlockChapter } from "./tabLock.js";

/** 챕터 잠금 대상 탭(unlockChapter>1) 목록 — `shouldShowUnlockDot` 갱신 순회 시 대상 집합으로 사용. */
export function chapterLockedTabs(): TabId[] {
  return TAB_ORDER.filter((id) => tabUnlockChapter(id) > 1);
}

/**
 * 탭 해금 레드닷 표시 여부 — 잠금이 풀렸고(bestChapter >= unlockChapter) 아직 진입·소비하지 않았으면 true.
 * 상시 해제 탭(unlockChapter 미지정 = 1)은 항상 false.
 * @param seen SaveData.tabUnlockSeen — 이미 진입해 소비한 탭 ID 목록. 탭 진입 시 해당 ID를 추가해 닷을 소비한다.
 */
export function shouldShowUnlockDot(
  tab: TabId,
  bestChapter: number,
  seen: readonly string[],
): boolean {
  return (
    tabUnlockChapter(tab) > 1 &&
    !isTabLocked(tab, bestChapter) &&
    !seen.includes(tab)
  );
}
